export enum PaymentStatus {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Authorized = 'authorized',
  Cancelled = 'cancelled',
  Chargeback = 'chargeback',
  Refused = 'refused',
  Refunded = 'refunded',
}
